//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/NXObject.js";
let d=[[],[[["link"],"SetRigidLink",{},1,0],[["link"],"SetFlexibleLink",{},1,0],[["link"],"SetSplineBeam",{},1,0],[["viewPort"],"SetViewPort",{},1,0],[["scale","updateDisplay"],"SetLoadVectorScale",{},2,0],[["step"],"SetAnimationCurrentStep",{},1,0],[[],"AnimationStepForward",{},0,0],[[],"AnimationStepBackward",{},0,0],[[],"PlayAnimation",{},0,0],[[],"StopAnimation",{},0,0],[[],"UpdateFromSpreadsheet",{},0,0],[[],"ExportToSpreadsheet",{},0,0],[[],"Finish",{},0,0]],[]];
SPLM.Motion.LoadTransferControl = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.LoadTransferControl";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;